/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from 'react';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/ArrowDown.svg';

import cx from 'classnames';
import { ReactComponent as TickIcon } from 'assets/icons/Tick_Thin.svg';
import { useOutsideClick } from 'hooks';
import styles from './ElecsumSelect.module.scss';

export interface SelectItemI {
  id: string;
  value: string | null;
  label: string;
}

interface ElecsumSelectPropsI {
  selected?: SelectItemI;
  values: Array<SelectItemI>;
  label: string;
  minWidth?: '7.5rem' | '10rem' | '12.5rem' | '15rem' | '17.5rem' | '20rem';
  onChange(element: SelectItemI): void;
  disabled?: boolean; // Add a disabled prop
}

const ElecsumSelect = (props: ElecsumSelectPropsI) => {
  const dropdownRef = useRef(null);
  const { selected, values, label, onChange, minWidth, disabled } = props; // Destructure the disabled prop

  const [open, setOpen] = useState(false);

  useOutsideClick(dropdownRef, () => {
    setOpen(false);
  });

  const getHeadLabel = (): string => {
    if (!selected) return `${label}`;
    if (selected.value === null) return `${label}`;
    return `${selected.value}`;
  };

  return (
    <div style={{ minWidth }} ref={dropdownRef} className={cx(styles.container, { [styles.disabled]: disabled })}>
      <button
        onClick={() => setOpen(!open)}
        className={cx(styles.head, { [styles.open]: open })}
        type="button"
        disabled={disabled} // Set the disabled prop on the button
      >
        <span className={styles.label}>{getHeadLabel()}</span>
        <ArrowDownIcon />
      </button>
      <ul className={cx(styles.items, { [styles.open]: open })}>
        {values.map((item) => (
          <li
            onClick={() => {
              setOpen(false);
              onChange(item);
            }}
            className={cx(styles.item, { [styles['item--selected']]: item.id === selected?.id })}
            key={item.id} // Add a unique key to each list item
          >
            <span>{item.label}</span>
            {item.id === selected?.id ? <TickIcon /> : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ElecsumSelect;
